"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardStats = void 0;
/* eslint-disable require-jsdoc */
const firestore_1 = require("firebase/firestore");
const types_1 = require("../main/types");
class CardStats extends types_1.CardStatsType {
    constructor(cardId) {
        super(cardId);
        this.lastStudyDate = firestore_1.Timestamp.now();
    }
}
exports.CardStats = CardStats;
CardStats.converter = {
    toFirestore(data) {
        return {
            score: data.score,
            perfectScore: data.perfectScore,
            maturityPoints: data.maturityPoints,
            difficulty: data.difficulty,
            answerTimes: data.answerTimes,
            reviewDueDate: data.reviewDueDate,
            lastReviewDuration: data.lastReviewDuration,
            reviewAnswerChance: data.reviewAnswerChance,
            firstChanceAttemptTimes: data.firstChanceAttemptTimes,
            secondChanceAttemptTimes: data.secondChanceAttemptTimes,
            thirdChanceAttemptTimes: data.thirdChanceAttemptTimes,
            returnToAcquisitionTimes: data.returnToAcquisitionTimes,
            lastStudyDate: data.lastStudyDate
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const cardId = snapshot.id;
        const data = new CardStats(cardId);
        data.score = documentData.score;
        data.perfectScore = documentData.perfectScore;
        data.maturityPoints = documentData.maturityPoints;
        data.difficulty = documentData.difficulty;
        data.answerTimes = documentData.answerTimes;
        data.reviewDueDate = documentData.reviewDueDate;
        data.lastReviewDuration = documentData.lastReviewDuration;
        data.reviewAnswerChance = documentData.reviewAnswerChance;
        data.firstChanceAttemptTimes = documentData.firstChanceAttemptTimes;
        data.secondChanceAttemptTimes = documentData.secondChanceAttemptTimes;
        data.thirdChanceAttemptTimes = documentData.thirdChanceAttemptTimes;
        data.returnToAcquisitionTimes = documentData.returnToAcquisitionTimes;
        data.lastStudyDate = documentData.lastStudyDate;
        return data;
    }
};
